var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import Button from "./Button";
import Icon from "../Icon";
const IconButton = forwardRef((_a, ref) => {
    var { icon, children, isRound, size, iconProps } = _a, rest = __rest(_a, ["icon", "children", "isRound", "size", "iconProps"]);
    const a11yProps = {
        "aria-hidden": true,
        focusable: false,
    };
    return (React.createElement(Button, Object.assign({ px: 0, ref: ref, size: size }, rest), React.isValidElement(children) ? (React.cloneElement(children, a11yProps)) : (React.createElement(Icon, Object.assign({}, a11yProps, { icon: icon, m: 0, size: size }, iconProps)))));
});
IconButton.displayName = "IconButton";
export default IconButton;
//# sourceMappingURL=IconButton.js.map